"use client";
import { useAspiration } from "@/components/parts/admin/aspiration/api";
import { subsColumnGuessUser } from "@/components/parts/admin/subsmision/column";
import AspirationCard from "@/components/sections/landing/aspirationCard";
import HeaderPage from "@/components/sections/landing/headerPage";
import DataTable from "@/components/shared/dataTable";
import Search from "@/components/shared/filter/search";
import TriggerAllFilter from "@/components/shared/filter/triggerAllFilter";
import YearFilter from "@/components/shared/filter/yearFilter";
import { BreadcrumbSetItem } from "@/components/shared/layouts/myBreadcrumb";
import Pagination from "@/components/shared/pagination";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

const AspirationListPage = () => {
  const searchParams = useSearchParams();
  const limit = searchParams.get("limit") || "10";
  const dapilId = searchParams.get("dapil") || "";
  const { data: Aspiration } = useAspiration(searchParams.toString(), "guest");
  const aspirationData = Aspiration?.data.items || [];
  const aspritationPagination = Aspiration?.data;
  const endpoint = dapilId
    ? `/aspiration/create?dapil=${dapilId}`
    : "/aspiration/create";

  return (
    <section>
      {dapilId ? (
        <BreadcrumbSetItem
          items={[
            {
              title: "Beranda",
              href: `/`,
            },
            {
              title: `Usulan Dapil ${dapilId}`,
            },
          ]}
        />
      ) : (
        <BreadcrumbSetItem
          items={[
            {
              title: "Beranda",
              href: `/`,
            },
            {
              title: `Usulan`,
            },
          ]}
        />
      )}
      <HeaderPage>Usulan</HeaderPage>
      <div className="md:container md:my-12 p-6">
        <div className="flex justify-end mb-4 gap-2">
          <Link download href="/assets/images/qr-usulan.png">
            <Button className="rounded-full">Unduh QR</Button>
          </Link>
          <Link href={endpoint}>
            <Button className="rounded-full">Tambah Usulan</Button>
          </Link>
        </div>
        <div className="flex gap-3">
          <TriggerAllFilter
            category
            electoralDistrict
            rangeDate
            fraction
            commission
          />
          <div className="flex-1">
            <Search name="search" />
          </div>
          <YearFilter />
        </div>
        {/*  */}

        <div className="mt-4 hidden md:block">
          <DataTable
            columns={subsColumnGuessUser(
              aspritationPagination?.page || 1,
              Number(limit) ?? 10
            )}
            data={aspirationData}
            currentPage={aspritationPagination?.page || 1}
            totalItems={aspritationPagination?.total_items || 0}
            itemsPerPage={Number(limit)}
            totalPages={aspritationPagination?.total_pages || 0}
          />
        </div>

        <div className="space-y-6 mt-6 block md:hidden">
          {aspirationData.map((item) => (
            <AspirationCard key={item.id} item={item} />
          ))}
          <div className="flex items-center justify-end space-x-2 py-4">
            <Pagination
              currentPage={aspritationPagination?.page ?? 1}
              totalItems={aspritationPagination?.total_items ?? 0}
              itemsPerPage={Number(limit)}
              totalPages={aspritationPagination?.total_pages || 0}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AspirationListPage;
